import { render, staticRenderFns } from "./skinPackageThree.vue?vue&type=template&id=665ce644&scoped=true"
import script from "./skinPackageThree.vue?vue&type=script&lang=js"
export * from "./skinPackageThree.vue?vue&type=script&lang=js"
import style0 from "./skinPackageThree.vue?vue&type=style&index=0&id=665ce644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ce644",
  null
  
)

export default component.exports